import React from "react";
import { Button } from "reactstrap";

const StepCompleteActionButton = ({ label, onClick, disabled }) => {
    return (
        <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
            <Button
                className="w-100"
                style={{
                    maxWidth: 400,
                    padding: "1rem",
                    fontSize: "1.2rem",
                    fontWeight: 600,
                    background: (label === "CONTINUE" || label === "SUBMIT" || label.includes("YES") || label.includes("PICTURE"))
                        ? "linear-gradient(90deg,rgba(42, 123, 155, 1) 0%, rgba(56, 150, 95, 1) 13%, rgba(44, 184, 77, 1) 52%, rgba(56, 150, 95, 1) 90%, rgba(42, 123, 155, 1) 100%)"
                        : label === "NO"
                            ? "linear-gradient(90deg,rgba(89, 0, 0, 1) 0%, rgba(150, 56, 56, 1) 13%, rgba(184, 74, 44, 1) 52%, rgba(150, 56, 56, 1) 90%, rgba(89, 0, 0, 1) 100%)"
                            : "linear-gradient(135deg, #1e1e1e, #4a4a4a)",
                    border: "none",
                }}
                onClick={onClick}
                disabled={disabled}
            >
                {label}
            </Button>
        </div>
    );
};

export default StepCompleteActionButton;